/* eslint-disable sonarjs/no-duplicate-string */

import { defineMessages } from "react-intl";
import { useMessages } from "2g-hooks/intl";

const MESSAGES = defineMessages({
  widgetLabel: {
    id: "b2b.zadosti-odsouhlasene-widget.label",
    defaultMessage: "Approved requests"
  },
  messageEmpty: {
    id: "b2b.zadosti-odsouhlasene-widget.message-empty",
    defaultMessage: "No approved requests."
  }
});

export default () => useMessages(MESSAGES);
